
import request from '../request'
import apis from '../apis'
import * as loadGlobal from '@/utils/loadingOpt.js'

export default {

    fechEnv(data) {
        // 进入展会资源首页或者处理进入工程开启loading，在路由拦截器里面会关闭此loading
        loadGlobal.openLoading()
        return request({ url: apis.GET_ENV, method: 'get', data });
    },

    fechLang(data) {
        return request({ url: apis.GET_LANG, method: 'get', data });
    },

    /** 第三方登录获取跳转机票火车票的地址 */
    getTravelLoginurlSer(params) {
        return request.get(`${apis.GET_TRAVEL_LOGIN_URL}`, { params });
    },

    /**
     * 国家、省、城市
     * @param {*} param
     */
    getCountryList({ param }) {
        return request.get(`${apis.GET_COUNTRY_LIST}`, { params: param });
    },

    /**
     * 展会默认币种名称
     * @param {*} param0
     */
    getDefaultCurrency({ param }) {
        return request.get(`${apis.GET_DEFAULT_CURRENCY}`)
    },

    /**
     * 时区
     * @param {*} param0
     */
    getTimeZone({ param }) {
        return request.get(`${apis.GET_TIME_ZONE}`)
    },
    // 获取是否关联ICIMS展会
    getIsIcimsExhiSer(params) {
        return request.get(apis.GET_IS_ICIMS_EXHI, { params });
    },
    // 查询lookup
    getLookUpData(params) {
        return request.get(apis.COMMON_LOOKUP_DATA, { params });
    },

    /** 上传附件 */
    uploadAttachmentSer({ formData, params }) {
        return request.post(apis.UPLOAD_ATTACHMENT, formData, { params });
    },
    switchLanguageSer({ formData, params }) {
        return request.get(apis.SWITCH_LANGUAGE, { params });
    }
}
